export default function doesBuildMatch(matchString: string, matchStrings: string[]): boolean {
    return !!matchStrings.some(s => {
        const reg = new RegExp(`^${s}$`);
        return reg.test(matchString);
    });
}
